<template>
  <footer
    class="w-full relative z-30"
    :class="useDarkFooter ? '-mt-14 tablet:-mt-20 lg:-mt-28' : '-mt-[25px]'"
  >
    <img
      v-if="useDarkFooter"
      src="@/assets/images/cache-bleu-fonce.svg"
      alt=""
      class="w-full block object-cover object-bottom pointer-events-none"
      aria-hidden="true"
    />
    <img
      v-else
      :src="cacheBleuUrl"
      alt=""
      class="footer-wave-image block pointer-events-none"
      aria-hidden="true"
    />
    <div
      :class="[
        'md:h-[90px] text-[white] w-full flex items-center justify-center py-[3%] md:py-0',
        useDarkFooter ? 'footer-bg-form' : 'footer-bg',
      ]"
    >
      <div class="w-full max">
        <!-- <div class="network">
          <a
            href="https://www.linkedin.com/company/petit-navire"
            target="_blank"
            ><i class="fa-brands fa-linkedin-in"></i
          ></a>
          <a
            href="https://www.instagram.com/petit_navire_fr/?hl=fr"
            target="_blank"
            ><i class="fa-brands fa-instagram"></i
          ></a>
          <a
            href="https://www.youtube.com/channel/UC8BZxz4XB_gaOnmzeeUO1Fg"
            target="_blank"
            ><i class="fa-brands fa-youtube"></i
          ></a>
          <a href="https://twitter.com/petitnavire" target="_blank"
            ><i class="fa-brands fa-x-twitter"></i
          ></a>

          <a
            href="https://www.facebook.com/PetitNavireOfficiel/"
            target="_blank"
            ><i class="fa-brands fa-facebook-f"></i
          ></a>
        </div> -->

        <ul
          class="md:flex text-sm lg:text-base text-center items-center justify-center gap-6 font-semibold"
        >
          <li>
            <a
              href="https://petitnavire.fr/fr/mentions-legales"
              target="_blank"
              rel="noopener noreferrer"
              >Mentions légales</a
            >
          </li>
          <li>
            <a
              href="https://petitnavire.fr/fr/mentions-legales#charte_de_confidentialite"
              target="_blank"
              rel="noopener noreferrer"
              >Charte de confidentialité</a
            >
          </li>
          <li>
            <a
              href="https://oxoformdocs.fra1.digitaloceanspaces.com/6904b53d310c505cd7f8a31f/Reglement.pdf"
              target="_blank"
              rel="noopener noreferrer"
              >Règlement</a
            >
          </li>
          <li>
            <router-link to="/dotations">Dotations</router-link>
          </li>
        </ul>
      </div>
    </div>
    <div
      class="md:h-[114px] py-4 bg-white text-[#0F3564] text-sm w-full flex items-center justify-center"
    >
      <div class="max text-center">
        <p class="mb-2">
          Nos emballages/produits, ainsi que nos supports de communication le
          cas échéant, peuvent faire l'objet d'une consigne tri. Pour en savoir
          plus :
          <a
            href="https://www.consignesdetri.fr"
            target="_blank"
            class="font-bold"
            >www.consignesdetri.fr</a
          >
        </p>
        <p>
          Pour votre santé, mangez au moins cinq fruits et légumes par jour.
          <a
            href="https://www.mangerbouger.fr"
            target="_blank"
            class="font-bold"
            >www.mangerbouger.fr</a
          >
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
import cacheBleu from "@/assets/images/cache-bleu.svg";

export default {
  name: "footer-view",
  data() {
    return {
      cacheBleuUrl: cacheBleu,
    };
  },
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
    currentPath() {
      return this.$route.path;
    },
    useDarkFooter() {
      return false;
    },
  },
};
</script>

<style scoped>
ul li {
  @apply py-2 tablet:py-0;
}

.footer-bg {
  background-color: #2490be;
}

.footer-bg-form {
  background-color: #0d2651;
}

.footer-wave-image {
  width: 100%;
  max-width: none;
  height: 18px;
  object-fit: cover;
  object-position: bottom center;
}

@media (max-width: 768px) {
  .footer-wave-image {
    height: 15px;
  }
}

.network {
  @apply flex items-center justify-center py-3 gap-4 max-w-xs mx-auto;
}

.network a {
  @apply inline-flex text-2xl text-[#0F3564] bg-white rounded-full h-10 w-10 items-center justify-center;
}
</style>
